/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Lcd_DoneInputs */

const tr_landing_telegram_mock_lcd_done = /** @type {(inputs: Landing_Telegram_Mock_Lcd_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ tamamlandı`)
};

const en_landing_telegram_mock_lcd_done = /** @type {(inputs: Landing_Telegram_Mock_Lcd_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ done`)
};

const de_landing_telegram_mock_lcd_done = /** @type {(inputs: Landing_Telegram_Mock_Lcd_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ fertig`)
};

const ru_landing_telegram_mock_lcd_done = /** @type {(inputs: Landing_Telegram_Mock_Lcd_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ завершено`)
};

/**
* | output |
* | --- |
* | "✓ done" |
*
* @param {Landing_Telegram_Mock_Lcd_DoneInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_lcd_done = /** @type {((inputs?: Landing_Telegram_Mock_Lcd_DoneInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Lcd_DoneInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_lcd_done(inputs)
	if (locale === "de") return de_landing_telegram_mock_lcd_done(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_lcd_done(inputs)
	return tr_landing_telegram_mock_lcd_done(inputs)
});